// extracted by mini-css-extract-plugin
module.exports = {"solutions":"styles_solutions__2OMCh","solutions__bg":"styles_solutions__bg__x4RAk","card":"styles_card__Qfch2","pulse":"styles_pulse__uyivt","jump":"styles_jump__8AZlF"};